import { render, staticRenderFns } from "./ruleListDialogScore.vue?vue&type=template&id=042276e6&scoped=true"
import script from "./ruleListDialogScore.vue?vue&type=script&lang=ts"
export * from "./ruleListDialogScore.vue?vue&type=script&lang=ts"
import style0 from "./ruleListDialogScore.vue?vue&type=style&index=0&id=042276e6&prod&lang=less"
import style1 from "./ruleListDialogScore.vue?vue&type=style&index=1&id=042276e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042276e6",
  null
  
)

export default component.exports